import { useOverflowContext as e } from "./overflow-context.js";
import { DATA_OVERFLOW_MENU as t } from "./constants.js";
import { useOverflowSnapshot as n } from "./use-overflow-snapshot.js";
import * as r from "react";
//#region src/shared/overflow/use-overflow-menu.ts
function i() {
	let i = r.useRef(null), a = e((e) => e.registerOverflowMenu), o = e((e) => e.updateOverflow), s = n((e) => e.invisibleItemCount), c = s > 0;
	return r.useLayoutEffect(() => {
		if (!i.current) return;
		let e = i.current;
		return e.setAttribute(t, ""), a(e);
	}, [a, c]), r.useLayoutEffect(() => {
		if (!i.current) return;
		let e = i.current;
		return e.setAttribute(t, ""), a(e);
	}, [a]), r.useLayoutEffect(() => {
		o();
	}, [c, o]), {
		ref: i,
		overflowCount: s,
		isOverflowing: c
	};
}
//#endregion
export { i as useOverflowMenu };
